import { render, staticRenderFns } from "./ReferencesSection.html?vue&type=template&id=f3c1755e&external"
import script from "./ReferencesSection.ts?vue&type=script&lang=ts&external"
export * from "./ReferencesSection.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports